import gql from "graphql-tag";
import {ComplianceEngineResultFragment, PaxNodeComplianceAuthorizationFieldsFragment} from "./Compliance";

export default gql`
query ISNResultQuery($_id: ID!){
    getPassenger(_id: $_id){
        _id
        _rev
        lastName
        firstName
        authorization{
            ...PaxNodeComplianceAuthorizationFieldsFragment
        }
        lastComplianceEngineResult {
            ...ComplianceEngineResultFragment
        }
    }
}
${PaxNodeComplianceAuthorizationFieldsFragment}
${ComplianceEngineResultFragment}
`